import styled from 'styled-components';

interface StyledProps {
  styledProps: {
    hasError: boolean;
  };
}

export const Container = styled.div`
  position: relative;
`;

export const StyledTextArea = styled.textarea<StyledProps>`
  width: 100%;
  height: 100px;
  resize: none;
  border-radius: 8px;
  border: ${({ theme }) => (theme.textarea?.border ? theme.textarea.border : '1px solid #ccc')};
  border-color: ${({ styledProps, theme }) => `${styledProps.hasError ? theme.input.errorColor : theme.input.border}`};
  transition: all 0.3s ease-in-out;
  color: ${({ theme }) => theme.input.color};
  padding: 12px 15px;
  font-size: ${({ theme }) => (theme.textarea?.fontSize ? theme.textarea.fontSize : '16px')};
`;

export const Error = styled.span`
  padding-top: 4px;
  font-size: 12px;
  color: ${({ theme }) => theme.input.errorColor};
`;
